<template>
    <div>
        <div class="register absolute">
            <div class="bg-bg">
                <div class="shading">
                    <div class="pictrue acea-row row-center-wrapper">
                        <img :src="logoUrl" v-if="logoUrl" />
                        <img src="@assets/images/logo2.png" v-else />
                    </div>
                    <div class="logo_name">
                        <img src="../../assets/newImg/login_1.png" alt="" />
                    </div>
                </div>
                <div class="bottom"></div>
                <!-- 注册 -->
                <div class="whiteBg" style="height: 310px">
                    <div class="title" style="line-height: 42px">注册账号</div>
                    <div class="list" style="margin-top: 0">
                        <div class="item">
                            <div>
                                <input type="text" placeholder="输入手机号码" v-model="account" />
                            </div>
                        </div>
                        <div class="item">
                            <div class="align-left">
                                <input type="text" placeholder="填写验证码" class="codeIput" v-model="captcha" />
                                <button class="code" :disabled="disabled" :class="disabled === true ? 'on' : ''" @click="code">
                                    {{ text }}
                                </button>
                            </div>
                        </div>
                        <div class="item">
                            <div>
                                <input type="password" placeholder="填写您的登录密码" v-model="password" />
                            </div>
                        </div>
                        <div class="item" v-if="isShowCode">
                            <div class="align-left">
                                <input type="text" placeholder="填写验证码" class="codeIput" v-model="codeVal" />
                                <div class="code" @click="again">
                                    <img :src="codeUrl" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="logon" @click="register">注册</div>
                </div>
            </div>
            <div class="agree">
                <van-checkbox v-model="checked">我已同意 </van-checkbox>
                <router-link to="/clause">
                    <span class="agree-txt" style="color: #4095ff; padding-left: 10px">注册条款</span>
                </router-link>
            </div>
        </div>
        <van-dialog v-model="show" title="温馨提示" show-cancel-button confirmButtonText="立即下载App" cancelButtonText="立即登录" @confirm="confirm" @cancel="submit">
            <div class="row-flex row-center-center" style="height:100px">账号已注册成功</div>
        </van-dialog>
    </div>
</template>
<script>
import sendVerifyCode from "@mixins/SendVerifyCode";
import Vue from "vue";
import { Checkbox } from "vant";
Vue.use(Checkbox);
import {
    login,
    registerVerify,
    register_wx,
    getCodeApi,
} from "@api/user";
import attrs, { required, alpha_num, chs_phone } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import { getLogo } from "@api/public";
import cookie from "@utils/store/cookie";
import { VUE_APP_API_URL, parseQuery } from "@utils";

const BACK_URL = "login_back_url";

export default {
    name: "Login",
    mixins: [sendVerifyCode],
    data: function() {
        return {
            navList: ["账号登录", "快速登录"],
            current: 1,
            account: "",
            password: "",
            captcha: "",
            formItem: 1,
            type: "register",
            logoUrl: "",
            keyCode: "",
            codeUrl: "",
            codeVal: "",
            isShowCode: false,
            checked: false,
            show: false,
            user_token: '',
        };
    },
    created() {
        let query = parseQuery();
        let urlSpread = query["uid"];
        if (urlSpread !== undefined) {
            var spread = localStorage.getItem("spread");
            urlSpread = parseInt(urlSpread);
            if (!Number.isNaN(urlSpread) && spread !== urlSpread) {
                localStorage.setItem("spread", urlSpread || 0);
            } else if (spread === 0 || typeof spread !== "number") {
                localStorage.setItem("spread", urlSpread || 0);
            }
        }
    },
    mounted: function() {
        this.getCode();
        this.getLogoImage();
        this.user_token = localStorage.getItem('baoshi_user_token');
        console.log('this.user_token---->', this.user_token);
    },
    methods: {
        again() {
            this.codeUrl =
                VUE_APP_API_URL +
                "/sms_captcha?" +
                "key=" +
                this.keyCode +
                Date.parse(new Date());
        },
        // 获取验证码
        getCode() {
            getCodeApi()
                .then((res) => {
                    this.keyCode = res.data.key;
                })
                .catch((res) => {
                    this.$dialog.error(res.msg);
                });
        },
        async getLogoImage() {
            let that = this;
            getLogo(2).then((res) => {
                that.logoUrl = res.data.logo_url;
            });
        },
        async code() {
            var that = this;
            const { account } = that;
            try {
                await that
                    .$validator({
                        account: [
                            required(required.message("手机号码")),
                            chs_phone(chs_phone.message()),
                        ],
                    })
                    .validate({ account });
            } catch (e) {
                return validatorDefaultCatch(e);
            }
            await registerVerify({
                    phone: that.account,
                    type: that.type,
                    key: that.keyCode,
                    code: that.codeVal,
                })
                .then((res) => {
                    that.$dialog.success(res.msg);
                    that.sendCode();
                })
                .catch((res) => {
                    if (res.data.status === 402) {
                        that.codeUrl = `${VUE_APP_API_URL}/sms_captcha?key=${that.keyCode}`;
                        that.isShowCode = true;
                    }
                    that.$dialog.error(res.msg);
                });
        },
        // 注册
        async register() {
            var that = this;
            const { account, captcha, password } = that;
            try {
                await that
                    .$validator({
                        account: [
                            required(required.message("手机号码")),
                            chs_phone(chs_phone.message()),
                        ],
                        captcha: [
                            required(required.message("验证码")),
                            alpha_num(alpha_num.message("验证码")),
                        ],
                        password: [
                            required(required.message("密码")),
                            attrs.range([6, 16], attrs.range.message("密码")),
                            alpha_num(alpha_num.message("密码")),
                        ],
                    })
                    .validate({ account, captcha, password });
            } catch (e) {
                return validatorDefaultCatch(e);
            }
            if (!that.checked) {
                return this.$dialog.toast({ mes: "请先同意注册条款" });
            }
            register_wx({
                    token: that.user_token,
                    account: that.account,
                    captcha: that.captcha,
                    password: that.password,
                    spread: localStorage.getItem("spread"),
                })
                .then((res) => {
                    that.$dialog.success(res.msg);
                    that.formItem = 1;
                    this.show = true;
                })
                .catch((res) => {
                    that.$dialog.error(res.msg);
                });
        },
        // 下载APP
        confirm() {
            window.location.href = "https://appstore.3todo.cn/baoshi/";
        },
        // 登录
        async submit() {
            const { account, password } = this;
            login({ account, password })
                .then(({ data }) => {
                    let expires_time = data.expires_time.substring(0, 19);
                    expires_time = expires_time.replace(/-/g, "/");
                    expires_time = new Date(expires_time).getTime() - 28800000;
                    const datas = {
                        token: data.token,
                        expires_time: expires_time,
                    };
                    this.$store.commit("LOGIN", datas);
                    const backUrl = localStorage.getItem(BACK_URL) || "/";
                    localStorage.removeItem(BACK_URL);
                    this.$router.replace({ path: backUrl });
                })
                .catch((e) => {
                    this.$dialog.error(e.msg);
                });
        },
    },
};
</script>
<style scoped>
.code img {
    width: 100%;
    height: 100%;
}

.logo_name img {
    width: 317px;
    margin: 24px 31px 0 21px;
    height: 59px;
}

.register .bottom {
    margin-top: 88px;
    width: 6.1rem;
}

.bg-bg {
    background: url("../../assets/newImg/login_bg.png") no-repeat;
    background-size: 100% 424px;
}

.register .whiteBg {
    margin-top: 0;
    width: 90%;
    height: 310px;
    box-shadow: 0px 1px 15px 0px rgba(157, 157, 157, 0.2);
}

.register {
    background: #ffffff;
    height: auto;
    min-height: 100vh;
}

.register .whiteBg .logon {
    width: 225px;
    height: 50px;
    line-height: 50px;
    border-radius: 100px;
    background: #d01112;
    margin: 30px auto auto auto;
}

.register .whiteBg .list {
    margin-top: 40px;
}

.register .whiteBg .list .item {
    background: #faf7f7;
    border-radius: 5px;
    height: 50px;
    line-height: 50px;
    padding: 0;
    display: flex;
    align-items: center;
    border-bottom: 0;
    margin-bottom: 20px;
}

.register .whiteBg .list .item input {
    padding-left: 20px;
}

input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 1000px #faf7f7 inset;
}

.register .whiteBg .title {
    display: flex;
    justify-content: space-around;
    width: 100%;
    height: 42px;
    color: #d01112;
}

.register .whiteBg .title .item~.item {
    margin-left: 0;
}

.register .whiteBg .tip {
    text-align: right;
}

.agree {
    width: 100%;
    text-align: center;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 1rem;
    padding-bottom: 0.5rem;
}

.register .shading .pictrue {
    background: none;
}

.under-line {
    text-decoration: underline;
}

.register .whiteBg .list .item .code {
    right: 20px;
}
</style>